import {FunctionalComponent, h} from "@stencil/core";
import {CheckboxCell, TableHeader, TableIconHeader, TableSkeleton, TextCell, Topic} from "./notification-settings.sub";
import type {Categories} from "../stores/userSettingsStore";

type Props = {
	topic: {headline: translationKey; text: translationKey};
	table: {
		categoryHeader: translationKey;
		notificationChannel: {caption: translationKey; tooltip: translationKey};
		eMailChannel: {caption: translationKey; tooltip: translationKey};
	};
	categories: Categories;
};

export const CategoriesFC: FunctionalComponent<Props> = ({topic, table, categories}, footer) => {
	const handleCheckboxChange = (categoryId: string, channelName: string, checked: boolean) => {
		const newData = structuredClone(categories.data);
		newData.find((category) => category.id === categoryId).channels.find((channel) => channel.name === channelName).enabled = checked;
		categories.update({data: newData});
	};

	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return (
		<section class="u-marginBottom-40">
			<Topic headline={topic.headline} text={topic.text} />
			<ux-table class="u-marginBottom-25" fullWidth mobileAccordion={false}>
				<table>
					<thead>
						<tr>
							<TableHeader caption={table.categoryHeader} />
							<TableIconHeader caption={table.notificationChannel.caption} icon="square-info" tooltip={table.notificationChannel.tooltip} />
							<TableIconHeader caption={table.eMailChannel.caption} icon="square-info" tooltip={table.eMailChannel.tooltip} />
						</tr>
					</thead>
					<tbody>
						{categories.isLoading || categories.hasFailedGet ? (
							<TableSkeleton columns={3} rows={2} noAnimation={categories.hasFailedGet} />
						) : (
							categories.data.map((category) => {
								const notificationChannel = category.channels.find((channel) => channel.name === "notificationChannel");
								const eMailChannel = category.channels.find((channel) => channel.name === "eMailChannel");

								// eslint-disable-next-line @typescript-eslint/no-unsafe-return
								return (
									<tr>
										<TextCell text={category.title} info={{icon: "square-info", tooltip: category.tooltip}} />
										<CheckboxCell
											name={notificationChannel.name}
											disabled={category.businessCritical}
											isChecked={notificationChannel.enabled}
											onChange={(e) => handleCheckboxChange(category.id, notificationChannel.name, (e.target as HTMLInputElement).checked)}
										/>
										<CheckboxCell
											name={eMailChannel.name}
											disabled={category.businessCritical}
											isChecked={eMailChannel.enabled}
											onChange={(e) => handleCheckboxChange(category.id, eMailChannel.name, (e.target as HTMLInputElement).checked)}
										/>
									</tr>
								);
							})
						)}
					</tbody>
				</table>
			</ux-table>
			{footer}
		</section>
	);
};
